<template>
  <div v-if="!isLoading && alertsArray.length > 0">
    <span class="title primary--text">
      {{ generateMessage('alerts.alert') }}
    </span>
    <span class="title font-weight-bold primary--text mr-auto">
      {{ generateMessage('alerts.hypervision') }}
    </span>
    <div
      :style="`height:${height}px; overflow-y: auto;`"
      class="d-flex flex-column align-center justify-space-around"
    >
      <div
        v-for="item in alertsArray"
        :key="item.name"
        class="d-flex flex-column align-center my-3"
      >
        <div class="mx-auto">
          {{ generateMessage(`alerts.fields.${item.name}`) }}
        </div>
        <div>
          <v-chip small class="mx-auto">{{ item.date | showDate }}</v-chip>
          <link-to-actionplan
            v-if="item.plan"
            color="success"
            :actionPlanId="item.plan"
            class="mx-auto"
          />
          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-icon color="error" v-on="on">
                {{ generateMessage('alerts.icons.remove') }}
              </v-icon>
            </template>
            <span>
              {{ generateMessage('requests.details.titles.no_actionplan') }}
            </span>
          </v-tooltip>
        </div>
        <div>{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ALL_ALERTS_TYPES } from '@/services/services/alertsService';
import { generateMessage } from '@/utils/i18n';
import LinkToActionplan from '@/components/tools/LinkToActionplan';
import { mapGetters } from 'vuex';

export default {
  name: 'AlertsLeftSide',
  components: { LinkToActionplan },
  props: {
    height: Number,
  },
  computed: {
    ...mapGetters({
      alerts: 'properties/alerts/current',
      isLoading: 'properties/alerts/isLoadingCurrent',
    }),
    alertsArray() {
      if (this.alerts) {
        return ALL_ALERTS_TYPES.map((alert) => ({
          name: alert.desc,
          date: new Date(this.alerts[alert.date]),
          plan: this.alerts[alert.plan],
          desc: this.alerts[alert.desc],
        })).filter((alert) => alert.desc);
      }
      return [];
    },
  },
  filters: {
    showDate(date) {
      return date.toLocaleDateString();
    },
  },
  methods: {
    generateMessage,
  },
};
</script>
